import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { UrlFormatter } from 'shared';

/**
 * Native port of the v1 `Platform` factory (account-v1/src/core/api/platform.js).
 * WS5 #10 Stage B B4a: replaces the `$injector.get('Platform')` grab in
 * ft-touchpoint-container (`loadWarmLeadHeader()` → `Platform.property({id})`).
 *
 * Only `property` is ported — the v1 factory's `brand` method has no native
 * consumer (don't over-port). Returns the response BODY (v1 `.then(r => r.data)`),
 * matching the established V1Api convention.
 */
@Injectable({ providedIn: 'root' })
export class PlatformV1ApiService {
  private readonly http = inject(HttpClient);

  /** v1 `Platform.property(model)` — model: `{id}`; GET `/api/:id/properties/:id/platform`. */
  property(model: any): Promise<any> {
    return firstValueFrom(
      this.http.get(UrlFormatter.format('/api/:id/properties/:id/platform', model)),
    );
  }
}
